<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Futuros"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Tipo de Operação</div>
    <div class="card-body">
      <div class="col" [class.has-error]="hasError('operationTypeId')">
        <div>
          <div
            class="form-check form-check-inline"
            *ngFor="let item of TiposCompra; index as i"
          >
            <input
              class="form-check-input"
              data-cy="operationTypeId"
              type="radio"
              id="TipoOperacao-{{ i }}-id"
              name="operationTypeId"
              [(ngModel)]="model.operationTypeId"
              [value]="item.id"
              required
            />

            <label class="form-check-label" for="TipoOperacao-{{ i }}-id">
              {{ item.name }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Futures"
  ></app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div
          class="col-4"
          [class.has-error]="
            (tradingDate.invalid &&
              (tradingDate.dirty || tradingDate.touched)) ||
            hasError('tradingDate')
          "
        >
          <label>Data do Pregão</label>
          <input
            placeholder="Select date"
            #tradingDate
            type="date"
            class="form-control"
            name="tradingDate"
            data-cy="tradingDate"
            [(ngModel)]="model.tradingDate"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="col-4"
          [class.has-error]="amount.invalid && (amount.dirty || amount.touched)"
        >
          <label>Quantidade</label>
          <input
            type="text"
            data-cy="amount"
            class="form-control"
            name="amount"
            [(ngModel)]="model.amount"
            #amount
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('unitPrice')">
          <label>PU (Preço Unitário)</label>
          <input
            type="text"
            data-cy="unitPrice"
            class="form-control"
            required
            [(ngModel)]="model.unitPrice"
            [textMask]="{ mask: validator.unitPriceMask }"
            name="unitPrice"
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('percentageDiscount')">
          <label>Percentual de Desconto</label>
          <input
            type="text"
            data-cy="percentageDiscount"
            class="form-control"
            name="percentageDiscount"
            [(ngModel)]="model.percentageDiscount"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div
          class="col-6"
          [class.has-error]="
            paperCode.invalid && (paperCode.dirty || paperCode.touched)
          "
        >
          <label>Código do Papel</label>
          <input
            type="text"
            data-cy="paperCode"
            class="form-control"
            name="paperCode"
            #paperCode
            [(ngModel)]="model.paperCode"
            maxlength="10"
            required
          />
        </div>
        <div
          class="col-6"
          [class.has-error]="
            paperSerie.invalid && (paperSerie.dirty || paperSerie.touched)
          "
        >
          <label>Série do Papel</label>
          <input
            type="text"
            data-cy="paperSerie"
            class="form-control"
            name="paperSerie"
            #paperSerie
            [(ngModel)]="model.paperSerie"
            maxlength="10"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div
          class="col-4"
          [class.has-error]="broker.invalid && (broker.dirty || broker.touched)"
        >
          <label>Nome Corretora Contraparte</label>
          <input
            type="text"
            data-cy="broker"
            class="form-control"
            name="broker"
            #broker
            [(ngModel)]="model.broker"
            maxlength="21"
            required
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('brokerDocument')">
          <label>CNPJ Corretora Contraparte</label>
          <input
            type="text"
            data-cy="brokerDocument"
            class="form-control"
            name="brokerDocument"
            [(ngModel)]="model.brokerDocument"
            #brokerDocument
            pattern="\d{2}[.]\d{3}[.]\d{3}\/\d{4}-\d{2}"
            [textMask]="{
              mask: validator.documentLegalPersonMask,
              guide: false
            }"
            required
          />
        </div>
        <div
          class="col-4"
          [class.has-error]="
            brokerCode.invalid && (brokerCode.dirty || brokerCode.touched)
          "
        >
          <label>Código da Corretora na B3</label>
          <input
            type="text"
            data-cy="brokerCode"
            class="form-control"
            name="brokerCode"
            #brokerCode
            [(ngModel)]="model.brokerCode"
            maxlength="15"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div
          class="col-6"
          [class.has-error]="
            brokerAccount.invalid &&
            (brokerAccount.dirty || brokerAccount.touched)
          "
        >
          <label>Conta Broker</label>
          <input
            class="form-control text-box single-line"
            data-cy="brokerAccount"
            name="brokerAccount"
            #brokerAccount
            [(ngModel)]="model.brokerAccount"
            type="text"
            maxlength="15"
            required
          />
        </div>
      </div>
    </div>
  </div>

  <br />

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <br />
  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="forward"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      data-cy="approve"
      value="Aprovar"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="reject"
      value="Reprovar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      data-cy="duplicate"
      value="Duplicar"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
